// extracted by mini-css-extract-plugin
module.exports = {"root":"page_root__5MxsE","main":"page_main__5HbGl","nonWhiteBg":"page_nonWhiteBg__EJ0_i"};